@let label = labelSg();
@let value = valueSg();
@let disabled = disabledSg();

<div class="atn-ds-input-field atn-ds-colorpicker__field">
  @if (label) {
    <span class="atn-ds-input-field__label">
      {{ label }}
    </span>
  }

  <div
    class="atn-ds-colorpicker__color-control"
    [class.atn-ds-colorpicker__color-control--disabled]="disabled"
  >
    <input
      class="atn-ds-colorpicker__input"
      type="color"
      [value]="value ?? '#000000'"
      (input)="selectColorHandler($event)"
      aria-label="Choose color"
      [disabled]="disabled"
    />
  </div>
</div>
